import {
  SET_CONSTRAINT_LIST,
} from './mutation-types'
import api from '@/api'

const state = {
  list: [],
}

const mutations = {
  [SET_CONSTRAINT_LIST] (state, payload) {
    state.list = payload
  },
}

const actions = {
  // 获取约束列表
  async getConstraintList ({commit}, payload) {
    let param = {
      ...payload,
    }
    const data = await api.deployApi.getConstraintList(param)
    commit(SET_CONSTRAINT_LIST, data.data)
  },
  // 新增和修改约束
  async handleConstraint ({dispatch, state}, {payload, listQuery}) {
    const data = await api.deployApi.handleConstraint(payload)
    if (data.result && data.code === 200) {
      let query = listQuery !== undefined ? listQuery : {}
      dispatch('getConstraintList', query)
    }
    return data
  },
  // 删除约束
  async deleteConstraint ({dispatch, state}, payload) {
    const data = await api.deployApi.deleteConstraint(payload)
    return data
  },
  // 获取约束名
  async storageConstraintName () {
    const {data} = await api.deployApi.storageConstraintName()
    return data === null ? [] : data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
